import React from "react";

import { Typography } from "clearsense-ui/components";

import FileName from "./FileName";
import Status from "./Status";

const getColumns = handleViewPdf => [
  {
    key: "fileName",
    dataIndex: "fileName",
    title: "File Name",
    width: "50%",
    sorter: (a, b) => a.fileName.localeCompare(b.fileName),
    render: (text, record) => (
      <FileName record={record} text={text} handleViewPdf={handleViewPdf} />
    ),
  },
  {
    key: "updatedAt",
    dataIndex: "updatedAt",
    title: "Last Modified",
    width: "20%",
    sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
    render: text => (
      <Typography
        style="large"
        className="text-content-dark dark:text-cs-ui-gray-500"
        data-cy="file-last-modified-date"
      >
        {text}
      </Typography>
    ),
  },
  {
    key: "status",
    dataIndex: "status",
    title: "Status",
    width: "10%",
    align: "center",
    sorter: (a, b) => a.status.localeCompare(b.status),
    render: (text, record) =>
      record.isDir ? <div className="ml-4">-</div> : <Status text={text} />,
  },
  {
    dataIndex: "confidence",
    key: "confidence",
    title: "Confidence",
    className: "break-normal",
  },
];

export { getColumns };
